// Actions
export const ANTICIPO_FETCH  = '[Anticipo] Fetch'

// Mutations
export const ANTICIPO_META   = '[Anticipo] meta'
export const ANTICIPO_OBTAIN = '[Anticipo] obtain'
export const ANTICIPO_CLEAR  = '[Anticipo] clear'
export const ANTICIPO_SET_LOADING = '[Anticipo] set loading'
